<template>
  <div>
    <AuthLayout />
    <ErrorReportModal />
  </div>
</template>

<script lang="ts">
import AuthLayout from "./Layouts/AuthLayout.vue";
import ErrorReportModal from "./components/Modals/ErrorReportModal.vue";

export default {
  name: "App",
  mounted() {
    console.log(`Working on '${import.meta.env.VITE_APP_MODE}' mode`);
  },
  components: { AuthLayout, ErrorReportModal },
};
</script>

<style></style>
